import React from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";
import "./TechCBT.css";

const TechCBT = () => {
  return (
    <>
      <div className="TechCBT mb-5">
        <div className="container">
          <div className="row px-lg-5">
            <div className="col-md-6">
              <h1 className="headings">
                <span>Blueberry </span>Travel Portal
              </h1>
              <p className="greotesk-headings cbt-description">
                Our Corporate Booking Tool (CBT) permits travelers to simply
                manage all their bookings on one convenient platform. With a
                personalized account, you'll have instant access to essential
                features like real-time travel updates, destination insights,
                and the latest travel advisories.
              </p>
              <div className="row mt-4">
                <div className="col-md-6">
                  <div className="cbt-card1">
                    <LazyLoadImage
                      src="https://blueberrywebsites.azureedge.net/bbt/images/cbtreport.png"
                      alt=""
                      loading="lazy"
                    />
                    <p className="greotesk-headings cbt-p">
                      Real-Time Reporting
                    </p>
                  </div>
                </div>
                <div className="col-md-6   mt-3 mt-md-0">
                  <div className="cbt-card1 cbt-card2">
                    <LazyLoadImage
                      src="https://blueberrywebsites.azureedge.net/bbt/images/cbtBooking.png"
                      alt=""
                      loading="lazy"
                    />
                    <p className="greotesk-headings cbt-p">
                      Centralized Bookings
                    </p>
                  </div>
                </div>
              </div>
              <div className="row mt-3">
                <div className="col-md-6">
                  <div className="cbt-card1 cbt-card3">
                    <LazyLoadImage
                      src="https://blueberrywebsites.azureedge.net/bbt/images/cbtApp.png"
                      alt=""
                      loading="lazy"
                    />
                    <p className="greotesk-headings cbt-p">
                      Personalized App Experience
                    </p>
                  </div>
                </div>
                <div className="col-md-6   mt-3 mt-md-0">
                  <div className="cbt-card1 cbt-card4">
                    <LazyLoadImage
                      src="https://blueberrywebsites.azureedge.net/bbt/images/cbtNews.png"
                      alt=""
                      loading="lazy"
                    />
                    <p className="greotesk-headings cbt-p">
                      Travel News & Updates
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="d-flex justify-content-center ms-xxl-5 ps-xxl-4 ms-lg-3">
                <LazyLoadImage
                  src="https://blueberrywebsites.azureedge.net/bbt/images/cbt-image.png"
                  alt=""
                  className="cbt-image"
                  loading="lazy"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default TechCBT;
